var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;



//////////////////
// WEBPACK FOOTER
// ./~/ngcomponent/~/lodash/_nativeCreate.js
// module id = ./node_modules/ngcomponent/node_modules/lodash/_nativeCreate.js
// module chunks = 1